import { Fragment, React, useEffect, useState } from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Button, Input, Modal, Select, Spin, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { EDIT_PROFILE, FETCH_QUALIFICATIONS } from '../../../actions/types';
import EditIcon from '../../../assets/images/edit-icon-blue.svg';
import ImageCropper from '../../../components/common/ImageCropper';
import Img from '../../../components/common/Img';
import QualificationModalBox from '../../../components/common/QualificationModalBox';
import { AppLocalStorage, AppStorageKeys } from '../../../contracts';
import { profilePictureUpdateService } from '../../../services/profile';
import { calcInputSize, conditionalCheckForQualificationMatch, getNumberOrText, openNotificationInToast, verifyIfUserCountryCodeIsPresent } from '../../../utilities';
import { INDIA_COUNTRY_CODE } from '../../../utilities/appStatics';
import { DefaultProfileIcon } from '../../../utilities/resources';

const antIcon = <LoadingOutlined style={{ fontSize: 14, color: '#fff' }} spin />;

const OTHERS_INDEX_FOR_QUALIFICATIONS = 14;

function EditProfile(props) {
  const { visibleModal, setVisibleModal } = props;
  const { Option } = Select;
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [userQualifications, setUserQualifications] = useState([]);
  const [profilePicture, setProfilePicture] = useState({ fileName: '', fileUrl: '', file: '' });
  const [profilePictureError, setProfilePictureError] = useState('');
  const [selectedOtherQualification, setSelectedOtherQualification] = useState(false);
  const [tempOtherQualification, setTempOtherQualification] = useState('');
  const [otherQualifications, setOtherQualifications] = useState([]);
  const [qualificationText, setQualificationText] = useState('');
  const [newQualificationIndex, setNewQualificationIndex] = useState(-1);
  const [spinLoader, setSpinLoader] = useState('');
  const [visibleImageCropperModal, setVisibleImageCropperModal] = useState(false);
  const [uploadedFile, setUploadedFile] = useState('');
  const {
    data: { qualifications },
  } = useSelector((state) => state.listings);
  const { userDetails, editStatus } = useSelector((state) => state.profile);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: FETCH_QUALIFICATIONS });
    setProfilePicture({ fileName: '', fileUrl: '', file: '' });
  }, []);

  useEffect(() => {
    const othersQualificationOption = {
      id: OTHERS_INDEX_FOR_QUALIFICATIONS,
      name: 'Others',
    };
    if (qualifications && qualifications.length > 0 && qualifications.indexOf(othersQualificationOption) < 0) {
      qualifications.push();
    }
  }, [qualifications]);

  useEffect(() => {
    if (userDetails && userDetails.users) {
      if (userDetails.users.qualification) {
        const qualiArr = userDetails.users.qualification.split(',');
        let userQuali = [];
        qualifications.forEach((quali) => {
          qualiArr.forEach((items) => {
            if (quali.name === items.trim()) {
              userQuali.push(quali.id);
            }
          });
        });
        setUserQualifications(userQuali);
        setQualificationText(userDetails.users.qualification);
      }
      setFirstName(userDetails.users.firstName);
      setLastName(userDetails.users.lastName);
    }
  }, [userDetails, qualifications]);

  const handleCancel = () => {
    setVisibleModal(false);
    setVisibleImageCropperModal(false);
    if (editStatus === 'success') {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  };

  const handleQualificationChange = (value) => {
    if (value.indexOf(OTHERS_INDEX_FOR_QUALIFICATIONS) >= 0) {
      setSelectedOtherQualification(true);
    } else {
      setUserQualifications(value);
    }
  };

  const handleQualificationTextChange = (value) => {
    setQualificationText(value);
  };

  const addOtherQualificationsToList = () => {
    if (tempOtherQualification && !getQualificationsMatchPresent()) {
      otherQualifications.push({
        id: newQualificationIndex,
        name: tempOtherQualification,
      });
      qualifications &&
        qualifications.length > 0 &&
        qualifications.push({
          id: newQualificationIndex,
          name: tempOtherQualification,
        });
      userQualifications.push(newQualificationIndex);
      setNewQualificationIndex(newQualificationIndex - 1);
    }
    setSelectedOtherQualification(false);
    setTempOtherQualification('');
  };

  const getQualificationsMatchPresent = () => {
    let qualificationCheck = '';
    qualifications &&
      qualifications.length > 0 &&
      qualifications.forEach((qualification) => {
        if (conditionalCheckForQualificationMatch(qualification.name, tempOtherQualification, true)) {
          qualificationCheck = qualification.name;
        }
      });
    return qualificationCheck;
  };

  const addTheQualificationMatchToList = (qualificationName) => {
    qualifications &&
      qualifications.length > 0 &&
      qualifications.forEach((qualification) => {
        if (qualification.name === qualificationName && userQualifications.indexOf(qualification.id) < 0) {
          userQualifications.push(qualification.id);
        }
      });
    setSelectedOtherQualification(false);
    setTempOtherQualification('');
  };

  const handleFirstNameChange = (e) => {
    setFirstName(getNumberOrText(e.target.value, e.keyCode));
  };

  const handleLastNameChange = (e) => {
    setLastName(getNumberOrText(e.target.value, e.keyCode));
  };

  const openProfilePicChangeModal = () => {
    setVisibleImageCropperModal(true);
    setVisibleModal(false);
  };

  const handleProfilePictureChange = (e) => {
    let file = e.target.files[0];
    if (file.type.includes('image')) {
      setProfilePicture({ fileName: file.name, fileUrl: URL.createObjectURL(file), file: file });
      setProfilePictureError('');
    } else {
      setProfilePictureError('Please attach image');
    }
  };

  const uploadProfilePicture = () => {
    if (uploadedFile !== '') {
      setSpinLoader(true);
      const formData = new FormData();
      formData.append('profilePicture', uploadedFile);

      profilePictureUpdateService(formData)
        .then((response) => {
          openNotificationInToast('success', 'Success!', 'Profile picture has been updated!');
          AppLocalStorage.save(AppStorageKeys.profilePic, response.users.profilePic);
          setSpinLoader(false);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
        })
        .catch((error) => {
          console.log(error);
          setSpinLoader(false);
        });
    }
  };

  const submitProfile = () => {
    let newOtherQualifications = [];
    userQualifications.map((qualificationId) => {
      otherQualifications.map((otherQualification) => {
        if (otherQualification.id === qualificationId) {
          newOtherQualifications.push(otherQualification);
        }
      });
    });
    const payload = {
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      qualificationIds: userQualifications,
      otherQualifications: newOtherQualifications,
      qualificationText: qualificationText,
    };
    dispatch({
      type: EDIT_PROFILE,
      payload: payload,
    });
  };

  return (
    <Fragment>
      <QualificationModalBox
        selectedOtherQualification={selectedOtherQualification}
        setSelectedOtherQualification={setSelectedOtherQualification}
        tempOtherQualification={tempOtherQualification}
        setTempOtherQualification={setTempOtherQualification}
        qualificationMatchPreset={getQualificationsMatchPresent()}
        addOtherQualificationsToList={addOtherQualificationsToList}
        addTheQualificationMatchToList={addTheQualificationMatchToList}
      />
      <Modal title='Upload Profile Picture' visible={visibleImageCropperModal} onCancel={handleCancel} footer={null} width='400px'>
        <ImageCropper setUploadedFile={setUploadedFile} uploadNow={uploadProfilePicture} spinLoader={spinLoader} />
      </Modal>
      <Modal title='Edit Basic Info' visible={visibleModal} onCancel={handleCancel} footer={null} width='785px'>
        <div className='profile_cover_popup'>
          <div className='profile_dp_preview'>
            <Img src={userDetails.users.profilePic} defaultSrc={DefaultProfileIcon} alt='profile' />
            <Tooltip title={'Edit Picture'}>
              <span onClick={openProfilePicChangeModal} className='profile_edit profielPicUpload'>
                <Img src={EditIcon} alt='Edit Icon' />
              </span>
            </Tooltip>
          </div>
          {profilePicture.fileName !== '' && (
            <button onClick={uploadProfilePicture} className='profilePicUploadButton'>
              {spinLoader ? (
                <Fragment>
                  Uploading <Spin indicator={antIcon} />
                </Fragment>
              ) : (
                'Upload Picture'
              )}
            </button>
          )}
        </div>
        {profilePictureError !== '' && <div className='error_text'>{profilePictureError}</div>}
        <div className='profile_popup_name'>
          <div>
            <span className='profile_popup_label'>First Name</span>
            <Input onChange={handleFirstNameChange} className='profile_popup_name_input' size='large' value={firstName} />
          </div>
          <div>
            <span className='profile_popup_label'>Last Name</span>
            <Input onChange={handleLastNameChange} className='profile_popup_name_input' size='large' value={lastName} />
          </div>
        </div>
        <div className='profile_popup_qualifications'>
          <span className='profile_popup_label'>Qualifications</span>
          {verifyIfUserCountryCodeIsPresent(userDetails) && userDetails.users.userCountry.code !== INDIA_COUNTRY_CODE ? (
            <Input
              value={qualificationText}
              onChange={(e) => handleQualificationTextChange(e.target.value)}
              size={calcInputSize}
              placeholder='Please enter your qualifications'
              allowClear
              autoComplete='off'
              // prefix={<SafetyCertificateOutlined />}
            />
          ) : (
            <Select
              size={calcInputSize}
              showSearch
              optionFilterProp='children'
              mode='multiple'
              showArrow
              allowClear
              autoComplete='off'
              notFoundContent='Please select "Others" option to add new qualification'
              style={{ width: '100%', marginTop: '6px' }}
              placeholder='Please select your qualifications'
              defaultValue={userQualifications}
              value={userQualifications}
              onChange={handleQualificationChange}
              filterOption={(input, option) => conditionalCheckForQualificationMatch(option.children, input, false)}
              virtual={false}
            >
              {qualifications &&
                qualifications.length > 0 &&
                qualifications.map((qualification) =>
                  qualification.name !== 'Others' ? (
                    <Option key={qualification.id} value={qualification.id}>
                      {qualification.name}
                    </Option>
                  ) : (
                    ''
                  )
                )}
              <Option key={OTHERS_INDEX_FOR_QUALIFICATIONS} value={OTHERS_INDEX_FOR_QUALIFICATIONS}>
                Others
              </Option>
            </Select>
          )}
        </div>
        <div className='changeModal_buttons'>
          <Button onClick={handleCancel} className='button_default'>
            Cancel
          </Button>
          <Button onClick={submitProfile} type='primary'>
            Update
          </Button>
        </div>
      </Modal>
    </Fragment>
  );
}

export default EditProfile;
